import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { CommonService } from './common.service';
import { map, Observable } from 'rxjs';
import { LocalDocumentType } from '../models/enums/hospital-document.enum';

@Injectable({
  providedIn: 'root',
})
export abstract class CommonRequestService extends CommonService {
  constructor(
    protected requestService: RequestService,
    protected root_path: string
  ) {
    super(root_path, requestService);
  }

  public submit(id: string): Observable<any> {
    return this.requestService.postJSON(
      `${this.root_path}/submit/${id}`,
      {
        data: { id },
        option: {
          is_loading: true,
          is_snack_bar: true,
        },
      },
      true
    );
  }

  public createHistory(status: string, data: any): Observable<any> {
    return this.requestService.postJSON(
      `${this.root_path}/history/${status}`,
      {
        data,
        option: {
          is_loading: true,
        },
      },
      true
    );
  }

  public getHistories(id: string): Observable<any> {
    return this.requestService.getJSON(`${this.root_path}/${id}/history`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }

  public uploadAttachment(
    files: FileList,
    type: LocalDocumentType
  ): Observable<any> {
    let data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append('file', files[i]);
    }
    data.append('type', type);
    return this.requestService.postData(`${this.root_path}/attachment`, {
      data: data,
      option: {
        is_loading: true,
      },
    });
  }

  public getAttachment(id: string): Observable<Blob> {
    return this.requestService.get(
      `${this.root_path}/attachment/` + id,
      {
        data: null,
        option: {
          is_loading: true,
        },
      },
      'blob'
    );
  }

  public deleteDocument(id: string, loading = true) {
    return this.requestService
      .deleteJSON(`${this.root_path}/attachment/${id}`, {
        option: {
          is_loading: loading,
        },
      })
      .pipe(
        map((res) => {
          const data = Object.assign(res, { data: { _id: id } });
          return data;
        })
      );
  }

  public delete(id: string): Observable<any> {
    return this.requestService.deleteJSON(`${this.root_path}/${id}/delete`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }

}
